import styled from "styled-components";
import Subheader from "./Subheader";

export default styled(Subheader)`
  padding: 24px 24px 0;
`;
